export enum CommandType {
    RENDER_INCENTIVE_V2 = "RenderIncentiveV2"
}